module.exports = __webpack_public_path__ + "img/instagram.726fba5c.png";